<template>
  <div class="detail-main">
    <Header :isShows='shows'></Header>
    <div class="videos">
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>
    </div>
    <div class="mains">
      <div class="title">
        {{ libDatas.ResouceName }}
      </div>
      <div class="vip" v-if="libDatas.Price == 1">认证会员专享</div>
      <div class="name">
        <van-icon name="contact" />
        <span>{{ libDatas.CreateName }}</span>
      </div>
      <div class="bottom">
        <div>
          <van-icon name="clock-o" />
          <span> {{ libDatas.CreateTime }}</span>
        </div>
        <div>
          <van-icon name="eye-o" /> <span>{{ libDatas.SeeNumber }}</span>
        </div>
        <div @click="showShare = true">
          <van-icon name="ellipsis" /> <span>分享</span>
        </div>
        <div v-if="libDatas.IsStore == 0" @click="collection(0)">
          <van-icon name="like-o" color="orange" /> <span>收藏</span>
        </div>
        <div v-if="libDatas.IsStore == 1" @click="collection(1)">
          <van-icon name="like" color="orange" /> <span>取消收藏</span>
        </div>
      </div>
    </div>
    <div class="mask" v-if="isShow" @click.stop="isShow = false">
      <img
        :src="url + libDatas.MobileUrl"
        class="QRcode"
        alt=""
        v-if="isShow"
      />
    </div>
    <div class="introduction">
      <div class="titles">资源简介：</div>
      <div class="mains" v-html="libDatas.Describe"></div>
    </div>
    <van-share-sheet
      v-model="showShare"
      title="立即分享给好友"
      :options="options"
      @select="onSelect"
    />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import caseApi from "@/api/caseApi";
import urls from "@/api/config";
export default {
  name: "libraryDetail",
  components: {
    Header,
  },
  data() {
    return {
      shows:false,
      id: "",
      url: urls,
      showShare: false,
      options: [
        { name: "微信", icon: "wechat" },
        // { name: "QQ", icon: "qq" },
      ],
      libDatas: {},
      isShow: false,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "", //url地址
          },
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
      },
    };
  },
  created() {
    this.id = this.$route.query.ids;

    let token = localStorage.getItem("token");
    if (!token) {
      this.$toast("未登录,将前往登录页");
      this.$router.push({ path: "/login" });
      return;
    }
    this.getdetail();
  },
  methods: {
    getdetail() {
      caseApi
        .detail({ resid: this.id })
        .then((res) => {
          this.libDatas = res.Data;
          this.libDatas.CreateTime = res.Data.CreateTime.replace("T", " ");
          this.playerOptions["sources"][0]["src"] = urls + res.Data.ResouceUrl;
        })
        .catch((error) => {
          if(error.response.status == 401){
             this.$toast("登录超时,请重新登录");
            this.$router.push({ path: "/login" });
          }
        });
    },
    // 收藏
    collection(codeType) {
      caseApi
        .SetStore({
          resid: this.id,
          type: codeType,
        })
        .then((res) => {
          if (codeType == 0) {
            this.libDatas.IsStore = 1;
          } else {
            this.libDatas.IsStore = 0;
          }
        });
    },
    onSelect(options) {
      console.log(options);
      // if (options.name == "QQ") {
      //   let url = window.location.href;
      //   let title = this.libDatas.ResouceName;
      //   let _shareUrl =
      //     "https://connect.qq.com/widget/shareqq/iframe_index.html?";
      //   _shareUrl += "url=" + encodeURIComponent(url || location.href);
      //   _shareUrl += "&title=" + encodeURIComponent(title || document.title);
      //   window.open(_shareUrl, "_blank");
      // } else {
      this.isShow = true;
      this.showShare = false;
      // }
    },
  },
};
</script>

<style scoped lang="scss">
.detail-main {
  overflow: hidden;
}
.videos {
  height: 260px;
}
.mains {
  text-align: left;
  padding: 0 15px;
  .title {
    font-size: 20px;
  }
  .vip {
    width: 23%;
    text-align: center;
    line-height: 22px;
    color: #fff;
    background: #f5c920;
  }
  .name {
    padding-top: 10px;
    color: #aaa;
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 20px;
    color: #aaa;
    div {
      overflow: hidden;
      height: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        display: inline-block;
        margin-left: 4px;
      }
    }
  }
}
.introduction {
  margin-top: 20px;
  padding: 0 15px;
  text-align: left;
  .titles {
    font-size: 20px;
    line-height: 2;
  }
  .mains {
    text-indent: 2em;
  }
}
.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
}
.QRcode {
  position: fixed;
  top: 220px;
  left: 20%;
  width: 60%;
}
</style>
